import { FC } from "react"
import { BlankStateSection } from "src/components/shared/BlankStateSection"
import { CenteredSpinner } from "src/components/shared/CenteredSpinner"
import { IPayment } from "src/domain/entities"
import { PaymentListView } from "."

interface Props {
	list: IPayment[]
	isLoading: boolean
	onUpdate: (payment: IPayment) => void
	onDelete: (payment: IPayment) => void
	onAddClick: () => void
}

export const PaymentListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return <BlankStateSection message="No payments found." onAddClick={onAddClick} />
	}

	return <PaymentListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
}
